import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

import type { BlogPostsMacroRendererProps } from '../src/BlogPostsMacroRenderer.tsx';

export const BlogPostsMacroHandler: LoadableType<BlogPostsMacroRendererProps> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogPostsMacro" */ '../src/BlogPostsMacroRenderer.tsx'
			)
		).BlogPostsMacroRenderer,
});
